<template>
	<div class='tips-content'>
		<el-dialog :visible.sync="dialogVisible" :show-close="false" @close="handleCloseDialog">
			<div class="content">
				<img src="../assets/img/log.png" alt="">
				<p>{{title}}</p>
				<span>{{content}}</span>
				<button @click="handleClose">我知道了</button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
  export default {
    name: "tips",
    data() {
      return {
        dialogVisible:false,
        title:'',
        content:'',
        time:""
      }
    },
    created() {
      this.$Bus.$off('tips').$on('tips',(value,data) =>{
        this.title = value
        this.content = data
        this.dialogVisible = true
        this.time = setTimeout(() => this.dialogVisible = false,3000)
      })
    },
    methods: {
      handleClose(){
        this.dialogVisible = false
        clearTimeout(this.time)
      },
      handleCloseDialog(){
        this.$route.query.name === 'money' ? this.$Bus.$emit('dialogClose'):''
      }
    }
  }
</script>

<style scoped lang='less'>
.tips-content{
	/deep/ .el-dialog__wrapper{
		z-index: 9999 !important;
		.el-dialog{
			width: 390px;
			border-radius: 8px;
			margin-top: 200px !important;
			.el-dialog__header{
				display: none;
			}
			.el-dialog__body{
				padding: 0;
			}
		}
	}
	.content{
		background-image: url("../assets/img/tips-icon.png");
		background-repeat: no-repeat;
		background-size: 100% 100%;
		height: 290px;
		width: 390px;
		overflow: hidden;
		img{
			width: 90px;
			height: auto;
			margin: 20px auto 50px;
		}
		p{
			text-align: center;
			color: #424a5e;
			font-size: 18px;
		}
		span{
			display: block;
			text-align: center;
			margin-top: 10px;
			color: #8d92a1;
			font-size: 15px;
		}
		button{
			width: 100px;
			height: 30px;
			background: #ffde00;
			border-radius: 20px;
			white-space: nowrap;
			font-size: 14px;
			color: #ffffff;
			margin: 15px auto 0;
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/pages/tips.vue